import { Block, Typography } from "@stepapp/ui";
import React from "react";

type ErrorMessageProps = {
  message?: string;
};

const ErrorMessage = ({ message }: ErrorMessageProps) => {
  return (
    <Block marginTop={1} minHeight={3}>
      {message ? (
        <Typography id="form-has-error" type="error" variant="paragraph">
          {message}
        </Typography>
      ) : null}
    </Block>
  );
};

export default React.memo(ErrorMessage);
